<template>
  <div class="dashboard-container">
    <!-- ===== 头部 ===== -->
    <div class="dashboard-header">
      <h1>{{ $t('_ybp._wdsy') }}</h1>
    </div>

    <!-- ===== 今日收益 ===== -->
    <div class="dkyk">
      <div class="today-card dksq">
        <div class="today-left">
          <div class="today-label">{{ $t('_ybp._jrsy') }}</div>
          <div class="today-amount">${{ profit?.today?.income?.jt || 0 }}</div>
          <div class="today-change" :class="profit?.today?.income?.rate >= 0 ? 'up' : 'down'">
            <i class="iconfont" :class="profit?.today?.income?.rate >= 0 ? 'icon-shangzhang' : 'icon-xiadie'"></i>
            <span class="change-label">{{ $t('_ybp._jztr') }}</span>
            <span> {{ (profit?.today?.income?.rate || 0).toFixed(2) }}%</span>
          </div>
        </div>
        <!-- <div class="today-right">
        <div class="metric-item">
          <span class="metric-label">{{ $t('_ybp._bfl') }}</span>
          <span class="metric-value">{{ formatNumber(1285621) }}</span>
          <span class="metric-change up">↑ 14.7%</span>
        </div>
        <div class="metric-item">
          <span class="metric-label">{{ $t('_ybp._dbl') }}</span>
          <span class="metric-value">{{ formatNumber(3421) }}</span>
          <span class="metric-change up">↑ 9.2%</span>
        </div>
      </div> -->
      </div>
      <!-- 右：账户余额 -->
      <div class="balance-card dksq">
        <div class="balance-header">
          <span class="balance-label">{{ $t('_ybp._dqye') }}</span>
        </div>
        <div class="balance-amount">
          <span class="balance-number">${{ profit.total || 0 }}</span>
        </div>
        <div class="balance-stats">
          <button class="btn btn-withdraw" @click="onWithdrawal">{{ $t('_m._tb') }}</button>
          <button class="btn btn-bank" @click="onBank" v-if="info.is_bank == 2">{{ $t('_m._yhzz') }}</button>
          <button class="btn btn-deposit" @click="onDeposit">{{ $t('_m._cb') }}</button>
        </div>
      </div>
    </div>

    <!-- 4列布局 -->
    <div class="dkyk">
      <!-- 左：待结算 -->
      <div class="today-card dksq">
        <div class="today-left">
          <div class="today-label">{{ $t('_ybp._djs_mt') }}</div>
          <div class="today-amount">${{ profit.settlement?.djs_mt || 0 }}</div>
          <div class="today-change" :class="profit?.settlement?.djs_zt >= 0 ? 'up' : 'down'">
            <!-- <i class="iconfont" :class="profit?.settlement?.djs_zt >= 0 ? 'icon-shangzhang' : 'icon-xiadie'"></i> -->
            <span class="change-label">{{ $t('_ybp._zrxz') }}</span>
            <span> {{ profit?.settlement?.djs_zt || 0 }}</span>
          </div>
        </div>
      </div>
      <!-- 点播量 -->
      <div class="today-card dksq">
        <div class="today-left">
          <div class="today-label">{{ $t('_ybp._dbl') }}</div>
          <div class="today-amount">{{ formatNumber(profit?.today?.buy?.jt || 0) }}</div>
          <div class="today-change" :class="profit?.today?.buy?.rate >= 0 ? 'up' : 'down'">
            <i class="iconfont" :class="profit?.today?.buy?.rate >= 0 ? 'icon-shangzhang' : 'icon-xiadie'"></i>
            <span class="change-label">{{ $t('_ybp._jztr') }}</span>
            <span> {{ (profit?.today?.buy?.rate || 0).toFixed(2) }}%</span>
          </div>
        </div>
      </div>
      <!-- 左：播放量 -->
      <div class="today-card dksq">
        <div class="today-left">
          <div class="today-label">{{ $t('_ybp._bfl') }}</div>
          <div class="today-amount">{{ formatNumber(profit?.today?.play?.jt || 0) }}</div>
          <div class="today-change" :class="profit?.today?.play?.rate >= 0 ? 'up' : 'down'">
            <i class="iconfont" :class="profit?.today?.play?.rate >= 0 ? 'icon-shangzhang' : 'icon-xiadie'"></i>
            <span class="change-label">{{ $t('_ybp._jztr') }}</span>
            <span> {{ (profit?.today?.play?.rate || 0).toFixed(2) }}%</span>
          </div>
        </div>
      </div>
      <!-- 右：转化率 点播/播放 -->
      <div class="today-card dksq">
        <div class="today-left">
          <div class="today-label">{{ $t('_ybp._zhl') }}</div>
          <div class="today-amount">{{ profit?.today?.zhrate?.jt || 0 }}%</div>
          <div class="today-change" :class="profit?.today?.zhrate?.rate >= 0 ? 'up' : 'down'">
            <i class="iconfont" :class="profit?.today?.zhrate?.rate >= 0 ? 'icon-shangzhang' : 'icon-xiadie'"></i>
            <span class="change-label">{{ $t('_ybp._jztr') }}</span>
            <span> {{ (profit?.today?.zhrate?.rate || 0).toFixed(2) }}%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 收益趋势 + 账户余额 两列布局 ===== -->
    <div class="row-two">
      <!-- 左：收益趋势 -->
      <div class="chart-card">
        <div class="chart-header">
          <span class="chart-title">{{ $t('_ybp._syqs') }}</span>
          <div class="chart-tabs">
            <span class="chart-tab active">7{{ $t('_ybp._t') }}</span>
            <!-- <span class="chart-tab">30{{ $t('_ybp._t') }}</span> -->
            <!-- <span class="chart-tab">90{{ $t('_ybp._t') }}</span> -->
          </div>
        </div>
        <div class="chart-body">
          <div class="chart-current">
            {{ $t('_ybp._jrsy') }}: <span class="chart-current-value">${{ formatNumber(profit?.today?.income?.jt || 0) }}</span>
          </div>
          <div class="chart-wrapper">
            <div ref="trendChart" style="width: 100%; height: 120px"></div>
          </div>
        </div>
      </div>

      <!-- ===== 数据概览 ===== -->
      <!-- <div class="overview-section">
        <div class="section-header">
          <span class="section-title">{{ $t('_ybp._sjgl') }}</span>
        </div>
        <div class="overview-grid">
          <div class="overview-item">
            <span class="overview-label">{{ $t('_ybp._zdsy') }}</span>
            <span class="overview-value">${{ profit?.complexs?.zsy || 0 }}</span>
          </div>

          <div class="overview-item">
            <span class="overview-label">{{ $t('_ybp._bysy') }}</span>
            <span class="overview-value">${{ profit?.complexs?.byzsy || 0 }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">{{ $t('_ybp._bfl') }}</span>
            <span class="overview-value">{{ formatNumber(profit?.complexs?.zbfl || 0) }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">{{ $t('_ybp._dbl') }}</span>
            <span class="overview-value">{{ formatNumber(profit?.complexs?.zdbl || 0) }}</span>
          </div>
          <div class="overview-item">
            <span class="overview-label">{{ $t('_ybp._zhl') }}</span>
            <span class="overview-value">{{ profit?.complexs?.zhl || 0 }}%</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- ===== 运营数据 ===== -->
    <div class="dkyk">
      <div class="operation-section dksq">
        <div class="section-header">
          <span class="section-title">{{ $t('_ybp._yysj') }}</span>
        </div>
        <div class="operation-grid">
          <!-- 左：总收益 -->
          <div class="operation-item">
            <span class="op-label">{{ $t('_ybp._zdsy') }}</span>
            <span class="op-value">${{ profit?.complexs?.zsy || 0 }}</span>
            <span class="op-change" :class="profit?.today?.income?.rate >= 0 ? 'up' : 'down'">
              {{ profit?.today?.income?.rate >= 0 ? '↑' : '↓' }}
              {{ (profit?.today?.income?.rate || 0).toFixed(2) }}%
            </span>
            <span class="op-yesterday">{{ $t('_ybp._zr') }} {{ profit?.complexs?.zt_sy || 0 }}</span>
          </div>
          <!-- 本月收益 -->
          <div class="operation-item">
            <span class="op-label">{{ $t('_ybp._bysy') }}</span>
            <span class="op-value">${{ profit?.complexs?.byzsy || 0 }}</span>
            <span class="op-change" :class="profit?.complexs?.m_rate >= 0 ? 'up' : 'down'">
              {{ profit?.complexs?.m_rate >= 0 ? '↑' : '↓' }}
              {{ (profit?.complexs?.m_rate || 0).toFixed(2) }}%
            </span>
            <span class="op-yesterday">{{ $t('_ybp._qygy') }} {{ profit?.complexs?.sm_sy || 0 }}</span>
          </div>
          <!-- 点播量 -->
          <div class="operation-item">
            <span class="op-label">{{ $t('_ybp._dbl') }}</span>
            <span class="op-value">{{ formatNumber(profit?.complexs?.zdbl || 0) }}</span>
            <span class="op-change" :class="profit?.today?.buy?.rate >= 0 ? 'up' : 'down'">
              {{ profit?.today?.buy?.rate >= 0 ? '↑' : '↓' }}
              {{ (profit?.today?.buy?.rate || 0).toFixed(2) }}%
            </span>
            <span class="op-yesterday">{{ $t('_ybp._zr') }} {{ formatNumber(profit?.complexs?.zt_dbl || 0) }}</span>
          </div>
          <!-- 播放量 -->
          <div class="operation-item">
            <span class="op-label">{{ $t('_ybp._bfl') }}</span>
            <span class="op-value">{{ formatNumber(profit?.complexs?.zbfl || 0) }}</span>
            <span class="op-change" :class="profit?.today?.play?.rate >= 0 ? 'up' : 'down'">
              {{ profit?.today?.play?.rate >= 0 ? '↑' : '↓' }}
              {{ (profit?.today?.play?.rate || 0).toFixed(2) }}%
            </span>
            <span class="op-yesterday">{{ $t('_ybp._zr') }} {{ formatNumber(profit?.complexs?.zt_bfl || 0) }}</span>
          </div>
          <!-- 转化率 -->
          <div class="operation-item">
            <span class="op-label">{{ $t('_ybp._zhl') }}</span>
            <span class="op-value">{{ profit?.complexs?.zhl || 0 }}%</span>
            <span class="op-change" :class="profit?.today?.zhrate?.rate >= 0 ? 'up' : 'down'">
              {{ profit?.today?.zhrate?.rate >= 0 ? '↑' : '↓' }}
              {{ (profit?.today?.zhrate?.rate || 0).toFixed(2) }}%
            </span>
            <span class="op-yesterday">{{ $t('_ybp._zr') }} {{ profit?.today?.zhrate?.zt || 0 }}%</span>
          </div>
        </div>
      </div>

      <!-- ===== 版权费用支付计划 ===== -->
      <div class="payment-section dksq">
        <div class="section-header">
          <span class="section-title">{{ $t('_ybp._bqfy') }}</span>
        </div>
        <div class="payment-grid">
          <div class="payment-item" v-for="(item, idx) in profit?.bq_data?.sy_data || []" :key="idx">
            <span class="payment-time">{{ item.time_period.begin }} - {{ item.time_period.end }}</span>
            <span class="payment-amount">$ {{ item.store_income }}</span>
            <!-- 预热中 -->
            <span class="payment-status" v-if="item.status == 1 && item.sort > item.now_sort">
              {{ $t('preheat') }}
            </span>
            <!-- 进行中 -->
            <span class="payment-status" v-else-if="item.status == 1">
              {{ $t('progress') }}
            </span>
            <!-- 已过期 -->
            <span class="payment-status gs" v-else-if="item.status == 3 && item.expired_seconds == 0">
              {{ $t('timeout') }}
            </span>
            <!-- 未支付 -->
            <span class="payment-status unpaid" v-else-if="item.status === 3" @click="onTransfer(profit?.bq_data?.user_adv, item)">
              {{ $t('_ybp._qzf') }}
            </span>
            <!-- 已过时 -->
            <span class="payment-status gs" v-else-if="item.status == 2 && item.store_income == 0">
              {{ $t('completedtlement') }}
            </span>
            <!-- 已支付 -->
            <span class="payment-status paid" v-else-if="item.status == 2">
              {{ $t('_ybp._yzf') }}
            </span>
          </div>
        </div>
        <div class="payment-tip">
          <i class="fas fa-info-circle"></i>
          {{ $t('_ybp._bqfyts') }}
        </div>
      </div>
    </div>
    <!-- ===== 结算记录 ===== -->
    <div class="dkyk">
      <div class="records-section dksq">
        <div class="section-header">
          <span class="section-title">{{ $t('_ybp._jsjl') }}</span>
          <a class="section-more" @click="onIncome()">{{ $t('_sy._jl') }} ></a>
        </div>
        <div class="records-list">
          <div class="record-item" v-for="(record, idx) in profit?.sy_list || []" :key="idx">
            <!-- <span class="record-date">{{ record.log_id }}</span> -->
            <span class="record-date">{{ record.code }}</span>
            <span class="record-amount">$ {{ record.target }}</span>
            <span class="record-date">{{ record.create_time }}</span>
            <!-- <span class="record-change up">↑ {{ record.change }}%</span> -->
          </div>
        </div>
      </div>

      <!-- ===== 划转记录 ===== -->
      <div class="activity-section dksq">
        <div class="section-header">
          <span class="section-title">{{ $t('_ybp._hzjl') }}</span>
        </div>
        <div class="activity-list">
          <div class="activity-item" v-for="(item, idx) in profit?.hz_list || []" :key="idx">
            <span class="activity-user">{{ item.code }}</span>
            <span class="activity-action">{{ formatSort(item.sort) }}</span>
            <span class="activity-amount">$ {{ item.number }}</span>
            <span class="activity-time">{{ formatTime(item.create_time) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 帮助中心 ===== -->
    <!-- <div class="help-section">
      <a class="help-link">{{ $t('_ybp._bzzx') }}</a>
      <span class="help-divider">|</span>
      <a class="help-link">{{ $t('_ybp._lxkf') }}</a>
    </div> -->

    <AdvTransfer ref="transfer" @success="onTransferSuccess"></AdvTransfer>
  </div>
</template>

<script>
// 使用 require 方式（兼容性更好）
const echarts = require('echarts')
import AdvTransfer from '@/components/adv/AdvTransfer.vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// 扩展 dayjs 插件
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: 'EarningsDashboard',
  components: { AdvTransfer },
  data() {
    return {
      info: {
        is_bank: 1
      },
      profit: {
        total: 0,
        today_profit: { profit: 0, rate: 0 },
        total_profit: { today: 0, total: 0 },
        video_adv: { today: 0, total: 0 },
        video_invest: { today: 0, total: 0 },
        profit_line: {},
        income_line: {}
      },
      incomeList: [],
      chartInstance: null,
      isChartReady: false,
      resizeTimer: null
    }
  },
  created() {
    this.getProfit()
  },
  mounted() {
    this.getInfo()
    this.$nextTick(() => {
      this.initChart()
    })
    // 使用防抖处理 resize 事件
    // window.addEventListener('resize', this.resizeChart)
  },
  beforeUnmount() {
    // 移除 resize 监听
    // window.removeEventListener('resize', this.resizeChart)
    // 清除定时器
    // if (this.resizeTimer) {
    //   clearTimeout(this.resizeTimer)
    //   this.resizeTimer = null
    // }
    // 销毁图表
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
      this.isChartReady = false
    }
  },
  computed: {
    maxTotal() {
      if (this.incomeList.length === 0) return 100
      const max = Math.max(...this.incomeList.map((item) => item.total || 0))
      return Math.ceil(max / 0.2) * 0.2 || 100
    },
    yAxisTicks() {
      const ticks = []
      for (let i = 0; i <= 5; i++) {
        ticks.push(((this.maxTotal * i) / 5).toFixed(1))
      }
      return ticks
    }
  },
  methods: {
    onIncome() {
      this.$router.push({ name: 'income' })
    },
    getInfo() {
      this.info = this.$common.getInfo() || { is_bank: 1 }
    },
    onDeposit() {
      this.$router.push({ name: 'deposit' })
    },
    onBank() {
      this.$router.push({ name: 'bank' })
    },
    onWithdrawal() {
      this.$router.push({ name: 'withdraw' })
    },
    onTransfer(video, item) {
      this.$refs.transfer.open(video, item)
    },
    onTransferSuccess() {
      this.getProfit()
    },
    getProfit() {
      this.$api.profit.getProfit().then((res) => {
        this.profit = res.data
        this.incomeList = []
        for (const date in this.profit.profit_line) {
          this.incomeList.push({
            date: date,
            income: this.profit.income_line?.[date] || 0,
            profit: this.profit.profit_line?.[date] || 0,
            total: (this.profit.income_line?.[date] || 0) + (this.profit.profit_line?.[date] || 0)
          })
        }
        this.$nextTick(() => {
          this.initChart()
        })
      })
    },

    // 防抖处理 resize
    resizeChart() {
      // 1. 检查图表实例是否存在
      if (!this.chartInstance) {
        return
      }

      if (this.chartInstance && this.isChartReady) {
        try {
          this.chartInstance.resize()
        } catch (e) {
          // 如果 resize 报错，忽略
          console.warn('Chart resize error:', e)
        }
      }
    },

    initChart() {
      const dom = this.$refs.trendChart
      if (!dom) {
        console.warn('Chart DOM not found')
        return
      }

      // 检查 echarts 是否可用
      if (typeof echarts === 'undefined') {
        console.warn('ECharts is not loaded')
        return
      }

      // 如果已有图表实例，先销毁
      if (this.chartInstance) {
        try {
          // this.chartInstance.dispose()
        } catch (e) {
          // 忽略销毁错误
        }
        this.chartInstance = null
        this.isChartReady = false
      }

      try {
        this.chartInstance = echarts.init(dom)
        this.isChartReady = true
      } catch (e) {
        console.error('ECharts init error:', e)
        return
      }

      const labels = this.incomeList.length > 0 ? this.incomeList.map((item) => item.date) : ['01/01', '01/02', '01/03', '01/04', '01/05', '01/06', '01/07']

      const data = this.incomeList.length > 0 ? this.incomeList.map((item) => item.total) : [0, 0, 0, 0, 0, 0, 0, 0]

      const option = {
        grid: {
          left: '3%',
          right: '3%',
          top: '10%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: labels,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#5a6672',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2a3038'
            }
          },
          axisLabel: {
            color: '#5a6672',
            fontSize: 10,
            formatter: function (value) {
              if (value >= 1000) {
                return '$' + (value / 1000).toFixed(1) + 'k'
              }
              return '$' + value.toFixed(0)
            }
          },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            type: 'line',
            data: data,
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: {
              color: '#ffb300',
              width: 2
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 179, 0, 0.15)' },
                { offset: 1, color: 'rgba(255, 179, 0, 0)' }
              ])
            },
            itemStyle: {
              color: '#ffb300'
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#1a1f26',
          borderColor: '#2a3038',
          borderWidth: 1,
          textStyle: {
            color: '#e8edf2',
            fontSize: 12
          },
          formatter: function (params) {
            if (!params || params.length === 0) return ''
            const p = params[0]
            return p.name + '<br/>' + '<span style="color:#ffb300;font-weight:bold;">$' + p.value.toFixed(2) + '</span>'
          }
        }
      }

      this.chartInstance.setOption(option)
    },

    formatCurrency(amount) {
      if (amount === undefined || amount === null) return '$0.00'
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amount)
    },

    formatNumber(num) {
      if (!num) return '0'
      //if (num >= 10000) {
      //  return (num / 10000).toFixed(1) + 'w'
      //} else
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'k'
      }
      return num.toString()
    },
    formatTime(timeStr, timezone = 'America/New_York') {
      try {
        // 1. 解析时间字符串 (MM/DD/YYYY HH:mm)
        const [datePart, timePart] = timeStr.split(' ')
        if (!datePart || !timePart) return timeStr

        const [month, day, year] = datePart.split('/').map(Number)
        const [hour, minute] = timePart.split(':').map(Number)

        // 2. 创建目标时间（假设传入的时间就是美国时间）
        const targetTime = dayjs()
          .tz(timezone)
          .set('year', year)
          .set('month', month - 1)
          .set('date', day)
          .set('hour', hour)
          .set('minute', minute)
          .set('second', 0)
          .set('millisecond', 0)

        // 3. 获取当前的美国时间
        const now = dayjs().tz(timezone)

        // 4. 计算时间差（分钟）
        const diffMinutes = now.diff(targetTime, 'minute')
        const diffHours = now.diff(targetTime, 'hour')

        // 5. 未来时间：直接返回原时间
        if (diffMinutes < 0) {
          return timeStr
        }

        // 6. 超过8小时（含8小时）：显示原时间
        if (diffHours >= 8) {
          return timeStr
        }

        // 7. 1小时以内：显示 X分钟前
        if (diffMinutes < 60) {
          return `${diffMinutes}${this.$t('_ybp._jfzq')}`
        }

        // 8. 1小时 ~ 8小时之间：显示 X小时前
        return `${diffHours}${this.$t('_ybp._fzq')}`
      } catch (error) {
        // 如果解析失败，返回原字符串
        return timeStr
      }
    },
    formatSort(sort, cha = 6) {
      let begin = sort * cha
      let end = begin + 6

      if (begin < 10) {
        begin = '0' + begin
      }
      if (end < 10) {
        end = '0' + end
      }

      let timesstr = `${begin}:00-${end}:00`
      return timesstr
    }
  }
}
</script>

<style scoped>
/* ============================================================
   收益仪表盘 - 运营看板风格
   ============================================================ */

.dashboard-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 16px 20px 40px;
  background: #0b0d0f;
  min-height: 100vh;
  color: #e8edf2;
}

/* ============================================================
   头部
   ============================================================ */
.dashboard-header {
  margin-bottom: 20px;
}
.dashboard-header h1 {
  font-size: 22px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
}

/* ============================================================
   今日收益
   ============================================================ */
.today-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 20px 24px;
  /* margin-bottom: 16px; */
}

.today-left {
  display: flex;
  flex-direction: column;
}
.today-label {
  font-size: 14px;
  color: #6a7a8a;
}
.today-amount {
  font-size: 38px;
  font-weight: 700;
  color: #e8edf2;
}
.today-change {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  padding: 2px 12px 2px 8px;
  border-radius: 12px;
  margin-top: 4px;
}
.today-change.up {
  color: #26a69a;
  background: rgba(38, 166, 154, 0.1);
}
.today-change.down {
  color: #ef5350;
  background: rgba(239, 83, 80, 0.1);
}
.change-label {
  font-weight: 400;
  color: #5a6672;
}

.today-right {
  display: flex;
  gap: 24px;
}
.metric-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.metric-label {
  font-size: 13px;
  color: #6a7a8a;
}
.metric-value {
  font-size: 16px;
  font-weight: 600;
  color: #e8edf2;
}
.metric-change {
  font-size: 12px;
  font-weight: 600;
}
.metric-change.up {
  color: #26a69a;
}

/* ============================================================
   两列布局
   ============================================================ */
.row-two {
  display: grid;
  /* grid-template-columns: 2fr 1fr; */
  gap: 16px;
  margin-bottom: 16px;
}

/* ============================================================
   图表卡片
   ============================================================ */
.chart-card {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 18px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
}
.chart-tabs {
  display: flex;
  gap: 4px;
}
.chart-tab {
  font-size: 13px;
  color: #5a6672;
  padding: 2px 12px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s;
}
.chart-tab.active {
  color: #ffb300;
  background: rgba(255, 179, 0, 0.08);
}
.chart-tab:hover {
  color: #e8edf2;
}

.chart-current {
  font-size: 13px;
  color: #5a6672;
  margin-bottom: 6px;
}
.chart-current-value {
  color: #ffb300;
  font-weight: 700;
}

.chart-wrapper {
  height: 120px;
  width: 100%;
}

/* ============================================================
   账户余额卡片
   ============================================================ */
.balance-card {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 18px 20px 16px;
}

.balance-header {
  display: flex;
  justify-content: space-between;
}
.balance-label {
  font-size: 14px;
  color: #6a7a8a;
}

.balance-amount {
  margin: 6px 0 12px;
}
.balance-number {
  font-size: 30px;
  font-weight: 700;
  color: #ffb300;
}

/* .balance-stats {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #2a3038;
} */
.balance-stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.balance-stat .stat-label {
  font-size: 13px;
  color: #6a7a8a;
}
.balance-stat .stat-value {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
}
.balance-stat .stat-change {
  font-size: 12px;
  font-weight: 600;
}
.balance-stat .stat-change.up {
  color: #26a69a;
}

/* ============================================================
   数据概览
   ============================================================ */
.overview-section {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 18px;
  /* margin-bottom: 16px; */
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
}
.section-more {
  font-size: 13px;
  color: #5a6672;
  cursor: pointer;
  text-decoration: none;
}
.section-more:hover {
  color: #ffb300;
}

.overview-grid {
  display: grid;
  /* grid-template-columns: repeat(5, 1fr); */
  gap: 10px;
}
.overview-item {
  display: flex;
  /* flex-direction: column; */
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.overview-label {
  font-size: 12px;
  color: #5a6672;
}
.overview-value {
  font-size: 16px;
  font-weight: 600;
  color: #e8edf2;
}

/* ============================================================
   运营数据
   ============================================================ */
.operation-section {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 18px;
  /* margin-bottom: 16px; */
}

.operation-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.operation-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.op-label {
  font-size: 12px;
  color: #5a6672;
}
.op-value {
  font-size: 18px;
  font-weight: 700;
  color: #e8edf2;
}
.op-change {
  font-size: 12px;
  font-weight: 600;
}
.op-change.up {
  color: #26a69a;
}
.op-change.down {
  color: #ef5350;
}
.op-yesterday {
  font-size: 12px;
  color: #4a5662;
}

/* ============================================================
   版权费用支付计划
   ============================================================ */
.payment-section {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 16px;
  /* margin-bottom: 16px; */
}

.payment-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 10px;
}
.payment-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  background: #0a0d0f;
  border-radius: 10px;
  border: 1px solid #2a3038;
}
.payment-time {
  font-size: 13px;
  color: #8a949f;
}
.payment-amount {
  font-size: 18px;
  font-weight: 700;
  color: #e8edf2;
}
.payment-status {
  font-size: 12px;
  font-weight: 600;
  padding: 2px 16px;
  border-radius: 12px;
  cursor: default;
}
.payment-status.gs {
  color: #9e9e9e;
  background: rgba(38, 166, 154, 0.1);
}
.payment-status.paid {
  color: #26a69a;
  background: rgba(38, 166, 154, 0.1);
}
.payment-status.unpaid {
  color: #ffb300;
  background: rgba(255, 179, 0, 0.1);
  cursor: pointer;
}
.payment-status.unpaid:hover {
  background: rgba(255, 179, 0, 0.2);
}

.payment-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #5a6672;
  padding: 8px 12px;
  background: #0a0d0f;
  border-radius: 8px;
}
.payment-tip i {
  color: #ffb300;
}

/* ============================================================
   收益记录
   ============================================================ */
.records-section {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 12px;
  /* margin-bottom: 16px; */
}

.records-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4px;
  border-bottom: 1px solid #2a3038;
}
.record-item:last-child {
  border-bottom: none;
}

.record-date {
  font-size: 14px;
  color: #8a949f;
}
.record-amount {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
}
.record-change {
  font-size: 13px;
  font-weight: 600;
}
.record-change.up {
  color: #26a69a;
}

/* ============================================================
   实时动态
   ============================================================ */
.activity-section {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 16px 20px 12px;
  /* margin-bottom: 16px; */
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.activity-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 4px;
  font-size: 14px;
  border-bottom: 1px solid #2a3038;
}
.activity-item:last-child {
  border-bottom: none;
}

.activity-user {
  color: #ffb300;
  font-weight: 600;
}
.activity-action {
  color: #8a949f;
}
.activity-amount {
  color: #e8edf2;
  font-weight: 600;
  margin-left: auto;
}
.activity-time {
  font-size: 12px;
  color: #4a5662;
}

/* ============================================================
   帮助中心
   ============================================================ */
.help-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 0 4px;
}
.help-link {
  font-size: 14px;
  color: #5a6672;
  text-decoration: none;
  cursor: pointer;
}
.help-link:hover {
  color: #ffb300;
}
.help-divider {
  color: #2a3038;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 820px) {
  .row-two {
    grid-template-columns: 1fr;
  }
  .overview-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .operation-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .payment-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .dashboard-container {
    padding: 12px 12px 30px;
  }
  .today-card {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .today-right {
    width: 100%;
    justify-content: space-between;
  }
  .today-amount {
    font-size: 28px;
  }
  .overview-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .operation-grid {
    grid-template-columns: 1fr;
  }
  .payment-grid {
    grid-template-columns: 1fr 1fr;
  }
  .balance-number {
    font-size: 24px;
  }
  .activity-item {
    flex-wrap: wrap;
    gap: 4px 6px;
  }
  .activity-amount {
    margin-left: 0;
  }
  .record-item {
    flex-wrap: wrap;
    gap: 4px;
  }
  .chart-wrapper {
    height: 80px;
  }
}

.dkyk {
  display: flex;
  gap: 15px;
  align-items: stretch;
  margin-bottom: 16px;
}

.dksq {
  flex: 1;
}

.balance-stats {
  display: flex;
  gap: 12px;
  padding-top: 14px;
  border-top: 1px solid #2a3038;
}

.balance-stats .btn {
  /* flex: 1; */
  width: 120px;
  padding: 10px 0;
  border: none;
  border-radius: 20px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}
.balance-stats .btn-bank {
  background: rgb(96 96 96 / 15%);
  color: #b4b4b4;
  border: 1px solid rgb(77 77 77);
}

.balance-stats .btn-withdraw {
  background: rgba(239, 83, 80, 0.15);
  color: #ef5350;
  border: 1px solid rgba(239, 83, 80, 0.2);
}

.balance-stats .btn-withdraw:hover {
  background: rgba(239, 83, 80, 0.25);
  transform: translateY(-2px);
}

.balance-stats .btn-deposit {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  box-shadow: 0 4px 16px rgba(255, 179, 0, 0.15);
}

.balance-stats .btn-deposit:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(255, 179, 0, 0.25);
}

.balance-stats .btn:active {
  transform: scale(0.97);
}
</style>
